import { AnimatePresence, motion } from "framer-motion";
import { COLORS } from "../constants/colors";

const slideVariants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
    position: "absolute",
  }),
  center: {
    x: 0,
    opacity: 1,
    position: "absolute",
  },
  exit: (direction) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0,
    position: "absolute",
  }),
};

const CarouselSection = ({ carouselItems, index, setIndex, direction }) => {
  const { title, desc, img } = carouselItems[index];

  return (
    <section
      className="py-20 px-8 md:px-20 rounded-3xl relative overflow-hidden"
      style={{ backgroundColor: COLORS.background }}
    >
      <h2
        className="text-4xl font-bold mb-12 text-center"
        style={{ color: COLORS.primaryDark }}
      >
        Core ERP Modules
      </h2>

      <div className="max-w-4xl mx-auto relative" style={{ height: 400, width: "100%" }}>
        <AnimatePresence initial={false} custom={direction}>
          <motion.div
            key={index}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.7, ease: "easeInOut" }}
            className="absolute top-0 left-0 w-full h-full rounded-3xl overflow-hidden shadow-xl cursor-pointer select-none"
          >
            <img
              src={img}
              alt={title}
              className="w-full h-full object-cover"
              draggable={false}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent flex flex-col justify-center px-10 md:px-16 text-white">
              <h3 className="text-4xl font-bold mb-4 drop-shadow-lg">
                {title}
              </h3>
              <p className="text-lg max-w-xl drop-shadow-md">{desc}</p>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Dots positioned at bottom center */}
        <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {carouselItems.map((_, i) => (
            <button
              key={i}
              onClick={() => {
                if (i === index) return;
                setIndex(i);
              }}
              style={{
                backgroundColor:
                  i === index ? COLORS.primary : COLORS.primaryLight,
              }}
              className="w-4 h-4 rounded-full transition-colors duration-300"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarouselSection;
